/**
 * This is the establishmemword service.
 * @memberOf establishmemword Module
 * @namespace establishmemword Service
 */

/**
 * @name establishmemwordService
 * @desc Create the service.
 * @param $q
 * @param establishmemwordDataService
 * @memberOf establishmemword Module establishmemword Service
 * @ngInject
 */
function establishMemwordFactory($q, establishMemwordDataService) {
    // Create the service.
    var service = {};
    return service;

}

export default establishMemwordFactory;



// WEBPACK FOOTER //
// ./src/login/establishmemword/establishmemword.service.js